export default function convertToTree(nodeArray) {
    let nArray = JSON.parse(JSON.stringify(nodeArray)) || [];
    const lowestLevelNodes = nArray.filter(r => !nArray.some(r2 => { var _a; return r2.parent_id === r.id || ((_a = r.member_ids) === null || _a === void 0 ? void 0 : _a.includes(r2.id)); }));
    for (const node of lowestLevelNodes) {
        const directParents = nArray.filter(r => r.id === node.parent_id) || [];
        const dottedLineParents = nArray.filter(r => { var _a; return (_a = r.member_ids) === null || _a === void 0 ? void 0 : _a.includes(node.id); }) || [];
        let tuckedIntoParents = false;
        for (const parent of directParents) {
            if (!parent.children)
                parent.children = [];
            parent.children.push(node);
            tuckedIntoParents = true;
        }
        for (const parent of dottedLineParents) {
            if (directParents.map(dp => dp.id).includes(parent.id))
                continue; // skipping if already has direct parent
            if (!parent.children)
                parent.children = [];
            parent.children.push(Object.assign(Object.assign({}, node), { name: '⋯' + node.name, icon: 'mdi-dots-vertical' }));
            tuckedIntoParents = true;
        }
        node.tuckedIntoParents = tuckedIntoParents;
    }
    nArray = nArray.filter(r => !r.tuckedIntoParents);
    if (nArray.some(r => nArray.some(r2 => { var _a; return (r2.id === r.parent_id || ((_a = r.member_ids) === null || _a === void 0 ? void 0 : _a.includes(r2.id))) && r2.id !== r.id; }))) {
        nArray = convertToTree(nArray);
    }
    return nArray;
}
